import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useDeleteDiscountPerkMutation = createMutationHook(
  MembershipsCreatorApiClient.deleteDiscountPerk,
  {
    mutationKey: ['deleteDiscountPerk'],
  },
)
